import React, { memo } from "react";
import { Outlet, useLocation } from "react-router-dom";

import {
  MissionsContainerStyled,
  MissionsListContentStyled,
} from "Components/MissionsPage/styles";
import { AsideFilters } from "Components/MissionPlanner/components/AsideFilters";
import { Header } from "Components/MissionsPage/components/Header/Header";
import { SearchContextHelper } from "Components/MissionsPage/SearchContextHelper";
import {
  LIVE_MISSIONS_PATH,
  QUEUE_MISSIONS_PATH,
} from "../../routers/AuthorizedRouter";

export const MissionsPage = memo(() => {
  const { pathname } = useLocation();
  const isNotOldMissionsPage =
    pathname.includes(LIVE_MISSIONS_PATH) || pathname === QUEUE_MISSIONS_PATH;

  return (
    <MissionsContainerStyled>
      <AsideFilters showVehiclesAndDates={!isNotOldMissionsPage} />
      <MissionsListContentStyled>
        <SearchContextHelper>
          <Header />
          <Outlet />
        </SearchContextHelper>
      </MissionsListContentStyled>
    </MissionsContainerStyled>
  );
});
